import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';

// STYLES
import { Container } from './styles';

const InfoList = ({ data, className }) => {
  return (
    <Container className={clsx('info-list', className)}>
      {data.map((item, index) =>
        item.value ? (
          <li className="info-list__item" key={index}>
            <Typography className="info-list__title p4" component="span" color="textSecondary">
              {item.title}:
            </Typography>
            <Typography component="span" variant="body2">
              {item.value}
            </Typography>
          </li>
        ) : null,
      )}
    </Container>
  );
};

InfoList.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default React.memo(InfoList);
